<template>
  <div id="app">
    <Header />
    <Banner />
    <Submission v-if="shouldShowSubmission" />
    <Loading v-if="false" />
    <router-view v-if="true" class="view" />
    <Footer v-if="true" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { constantsComputed } from '@/store/helpers'
import { getApiBaseURL } from '@/environments'
import Header from '@/components/Header/Main'
import Banner from '@/components/Banner/Main'
import Footer from '@/components/Footer/Main'
const Loading = () => import('@/components/Loading/Page')
const Submission = () => import('@/components/Submission/Main')

export default {
  components: {
    Loading,
    Header,
    Banner,
    Submission,
    Footer
  },

  metaInfo () {
    const title = this.$route.meta.title || 'Adman Awards & Symposium'
    const description = 'Adman Awards & Symposium celebrates excellence in Thai advertising and creativity through awards, events, and industry insights.'
    const canonical = `${window.location.origin}${this.$route.path}`

    return {
      title,
      htmlAttrs: {
        lang: 'th'
      },
      meta: [
        { vmid: 'description', name: 'description', content: description },
        { vmid: 'robots', name: 'robots', content: 'index, follow' },
        { vmid: 'og-url', property: 'og:url', content: canonical },
        { vmid: 'og-title', property: 'og:title', content: title },
        { vmid: 'og-description', property: 'og:description', content: description },
        { vmid: 'og-image', property: 'og:image', content: 'https://upload.admanawards.com/images/og-adman.png' },
        { vmid: 'og-site-name', property: 'og:site_name', content: 'Adman Awards' },
        { vmid: 'og-type', property: 'og:type', content: 'website' },
        { vmid: 'twitter-card', name: 'twitter:card', content: 'summary_large_image' },
        { vmid: 'twitter-title', name: 'twitter:title', content: title },
        { vmid: 'twitter-description', name: 'twitter:description', content: description },
        { vmid: 'twitter-image', name: 'twitter:image', content: 'https://upload.admanawards.com/images/og-adman.png' }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: canonical }
      ]
    }
  },

  data () {
    return {}
  },

  computed: {
    ...constantsComputed,
    ...mapState({
      loadBanner: state => state.banner.isLoading,
      loadSponsor: state => state.sponsor.isLoading
    }),

    shouldShowSubmission () {
      const submissionBtn = this.configMap.get('submissionBtn')
      const urlAward = this.$route.path.includes('awards')
      if (!urlAward) return false
      if (!submissionBtn) return false
      return submissionBtn.isDisplay
    }
  },

  methods: {
    preloadHomeBanner () {
      if (this.$route.name !== 'home' || document.getElementById('home-banner-preload')) return

      const isDesktop = window.matchMedia('(min-width: 1024px)').matches
      const filename = isDesktop
        ? '1783926782Adman Awards & Symposium 2026 Theme Banner_Desktop1920x850 px.jpg'
        : '1783926782Adman Awards & Symposium 2026 Theme Banner_Mobile 1127x958 px.jpg'
      const preload = document.createElement('link')
      preload.id = 'home-banner-preload'
      preload.rel = 'preload'
      preload.as = 'image'
      preload.href = `${getApiBaseURL()}/storage/app/img/banner/${filename}`
      preload.fetchPriority = 'high'
      document.head.appendChild(preload)
    },

    handleBeforeUnload () {
      sessionStorage.removeItem('symposium_room_id_selected')
    },

    improveCookieBannerAccessibility () {
      const banner = document.querySelector('.k_cookie_bar-wrap')
      if (!banner) return

      const logoLink = banner.querySelector('a.k_logo')
      if (logoLink) {
        logoLink.setAttribute('aria-label', 'Kensento cookie consent provider')
        logoLink.setAttribute('rel', 'noopener noreferrer')
      }

      if (this.cookieBannerObserver) {
        this.cookieBannerObserver.disconnect()
      }
      if (this.cookieBannerObserverTimeout) {
        window.clearTimeout(this.cookieBannerObserverTimeout)
      }
    }
  },

  watch: {
    $route () {
      window.scrollTo(0, 0)
      this.$store.dispatch('banner/get', this.$route.name)
      this.$store.dispatch('symposium/setIsSymposium', this.$route.name)

      if (
        this.$route.name !== 'symposium_video' &&
        this.$route.name !== 'symposium_video_detail'
      ) {
        sessionStorage.removeItem('symposium_room_id_selected')
      }
    }
  },

  async beforeCreate () {
    await this.$store.dispatch('constants/getConfigs')
  },

  async created () {
    this.preloadHomeBanner()
    await this.$store.dispatch('symposium/setIsSymposium', this.$route.name)
  },

  mounted () {
    window.addEventListener('beforeunload', this.handleBeforeUnload)

    this.cookieBannerObserver = new MutationObserver(this.improveCookieBannerAccessibility)
    this.cookieBannerObserver.observe(document.body, { childList: true, subtree: true })
    this.improveCookieBannerAccessibility()
    this.cookieBannerObserverTimeout = window.setTimeout(() => {
      this.cookieBannerObserver.disconnect()
    }, 10000)
  },

  beforeDestroy () {
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
    if (this.cookieBannerObserver) {
      this.cookieBannerObserver.disconnect()
    }
    if (this.cookieBannerObserverTimeout) {
      window.clearTimeout(this.cookieBannerObserverTimeout)
    }
  }
}
</script>

<style lang="scss">
.view {
  animation: opacity 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
}

@keyframes opacity {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
